// footer accordian
$(document).ready(function() {
  $(document).on('click', '.rating-wrapper', function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $('#judgeme_product_reviews').offset().top - 150
    }, 600);
  });
    // Load previously opened FAQ from localStorage
    const openId = localStorage.getItem("openFaqId");
    if (openId) {
        const $item = $(`.faq-item[data-id="${openId}"]`);
        $item.addClass("active");
        $item.find(".faq-answer").slideDown();
    }

    $(".faq-question").on("click", function() {
        const $item = $(this).closest(".faq-item");

        // Collapse all others
        $(".faq-item").not($item).removeClass("active").find(".faq-answer").slideUp();

        // Toggle this one
        $item.toggleClass("active");
        $item.find(".faq-answer").slideToggle();

        // Save to localStorage if open
        if ($item.hasClass("active")) {
            localStorage.setItem("openFaqId", $item.data("id"));
        } else {
            localStorage.removeItem("openFaqId");
        }
    });
    
});


function moveBlocker() {
    const $blocker = $(".bacurr-cur-blocker");

    if ($blocker.length === 0) {
        // Retry only for a limited time to avoid infinite loops
        setTimeout(moveBlocker, 300);
        return;
    }

    if (window.innerWidth <= 991) {
        // Move after .cus-dropdown-menu .sidebar .menu-drawer
        const $menuDrawer = $(".cus-dropdown-menu .sidebar .menu-drawer");
        if ($menuDrawer.length && !$blocker.prev().is($menuDrawer)) {
            $blocker.insertAfter($menuDrawer);
        }
    } else {
        // Move before .header__icon--account
        const $accountIcon = $(".header__icon--account");
        if ($accountIcon.length && !$blocker.next().is($accountIcon)) {
            $blocker.insertBefore($accountIcon);
        }
    }
}

// Debounce resize handler to improve performance
let resizeTimer;
$(window).on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(moveBlocker, 200);
});

// Initial run
$(document).ready(moveBlocker);

// ===============================================================
// Header Search css

document.addEventListener("DOMContentLoaded", function() {
    const collectionNames = ["Lehenga", "Saree", "Gown", "Anarkali", "Bridal Wear", "Kurti", "Designer Suits"];
    const elements = document.querySelectorAll(".collectionText");
    elements.forEach(textElement => {
        let collectionIndex = 0;
        let charIndex = 0;
        const typingSpeed = 150;
        const delayBetweenWords = 2000;

        function typeText() {
            if (charIndex < collectionNames[collectionIndex].length) {
                textElement.textContent += collectionNames[collectionIndex].charAt(charIndex);
                charIndex++;
                setTimeout(typeText, typingSpeed);
            } else {
                setTimeout(() => {
                    textElement.textContent = "";
                    charIndex = 0;
                    collectionIndex = (collectionIndex + 1) % collectionNames.length;
                    typeText();
                }, delayBetweenWords);
            }
        }
        typeText();
    });
});
// search model js
document.addEventListener("DOMContentLoaded", function() {
    const input = document.querySelector(".search__input");

    if (input && input.value.trim() === "") {
        const prefix = "Search for ";
        const words = ["Sarees", "Lehengas", "Gowns", "Kurtis"];
        let wordIndex = 0;
        let charIndex = 0;
        let isDeleting = false;

        function typeEffect() {
            const currentWord = words[wordIndex];
            const displayText = isDeleting ?
                currentWord.substring(0, charIndex--) :
                currentWord.substring(0, charIndex++);

            // ✅ Always keep prefix + dynamic part
            input.setAttribute("placeholder", prefix + displayText);

            if (!isDeleting && charIndex === currentWord.length) {
                isDeleting = true;
                setTimeout(typeEffect, 1500);
            } else if (isDeleting && charIndex === 0) {
                isDeleting = false;
                wordIndex = (wordIndex + 1) % words.length;
                setTimeout(typeEffect, 500);
            } else {
                setTimeout(typeEffect, isDeleting ? 80 : 120);
            }
        }

        typeEffect();
    }
});
// input serch functionality
document.addEventListener("DOMContentLoaded", function() {
    const searchInput = document.querySelector(".search__input");
    if (searchInput) {
        searchInput.addEventListener("keydown", function(e) {
            if (e.key === "Enter") {
                const query = searchInput.value.trim();
                if (query.length > 0) {
                    window.location.href = `/search?q=${encodeURIComponent(query)}`;
                }
            }
        });
    }
});

document.addEventListener("click", function(e) {
    if (e.target.closest(".header__icon--search")) {
        setTimeout(function() {
            const defaultSearch = document.querySelector(".predictive-search__default");
            const searchInput = document.querySelector("#Search-In-Modal-1");

            if (defaultSearch && searchInput) {
                defaultSearch.style.display = "block";
                searchInput.addEventListener("input", function() {
                    if (this.value.trim() === "") {
                        defaultSearch.style.display = "block";
                    } else {
                        defaultSearch.style.display = "none";
                    }
                });
            }
        }, 300);
    }
});

// cart bestseller (Splide version)
(function(){
  var $ = window.jQuery;

  function initBestsellerSlider() {
    var $cartslideE1 = document.querySelector('.main-cart-bestseller .cart-bestseller-products');
    if (!$cartslideE1) return;

    if ($cartslideE1.classList.contains('is-splide-initialized')) return;

    // Wait until product cards exist
    var productCardsBest = $cartslideE1.querySelectorAll('.cart-bestseller-product-card');
    if (productCardsBest.length === 0) {
      console.log('⏳ Waiting for bestseller products...');
      setTimeout(initBestsellerSlider, 300);
      return;
    }

    $cartslideE1.classList.add('is-splide-initialized');

    // Ensure proper Splide structure
    if (!$cartslideE1.classList.contains('splide')) {
      $cartslideE1.classList.add('splide');

      var track = document.createElement('div');
      track.className = 'splide__track';

      var list = document.createElement('ul');
      list.className = 'splide__list';

      productCardsBest.forEach(function(card){
        var slide = document.createElement('li');
        slide.className = 'splide__slide';
        slide.appendChild(card);
        list.appendChild(slide);
      });

      track.appendChild(list);
      $cartslideE1.appendChild(track);
    }

    // ✅ Initialize Splide with autoplay + gap
    var splidecart_best = new Splide($cartslideE1, {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      autoplay: true,
      interval: 2500,
      pauseOnHover: false,
      pauseOnFocus: false,
      rewind: true,
      speed: 600,
      arrows: false,
      pagination: false,
      gap: '10px', // 👈 space between slides
      drag: true,
      breakpoints: {
        768: { perPage: 2, gap: '8px' }
      }
    });

    splidecart_best.on('mounted', function(){
      $cartslideE1.style.opacity = '1';
    });

    splidecart_best.mount();
    console.log('✅ Splide initialized with autoplay and spacing');
  }

  // Run on load
  $(document).ready(initBestsellerSlider);

  // Re-init when cart updates
  $(document).on('cart:updated cart:change drawer:open drawer:updated ajaxCart.afterRender ajaxCart.cartUpdated', function(){
    setTimeout(initBestsellerSlider, 200);
  });

  // Observe cart drawer DOM changes
  var observer = new MutationObserver(function(mutations){
    mutations.forEach(function(m){
      m.addedNodes.forEach(function(node){
        if (node.nodeType === 1 && node.querySelector && node.querySelector('.main-cart-bestseller .cart-bestseller-products')) {
          setTimeout(initBestsellerSlider, 200);
        }
      });
    });
  });

  var drawer = document.querySelector('#CartDrawer, .cart-drawer, .ajaxcart, .mini-cart');
  if (drawer) {
    observer.observe(drawer, { childList: true, subtree: true });
  }
})();






// Whatemore Slider Arrow
const arrow = document.querySelector('.whatmore-carousel-events');

if (arrow) {
  const arrowobserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (!node.querySelector('.whatmore-arrow')) {
            node.insertAdjacentHTML('beforeend', '<div class="whatmore-arrow"></div>');
          }
        }
      });
    });
  });

  // observe the container you actually selected
  arrowobserver.observe(arrow, { childList: true });
}

const target = document.body;
const whatmoreobserver = new MutationObserver(() => {
  let prevBtns = document.querySelectorAll(".whatmore-render-root .swiper-button-prev");
  let nextBtns = document.querySelectorAll(".whatmore-render-root .swiper-button-next");

  if (prevBtns.length && nextBtns.length) {
    prevBtns.forEach(btn => btn.innerHTML = `<svg class="whatmore_prev" width="71" height="8" viewBox="0 0 71 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.646446 3.65646C0.451187 3.85172 0.451187 4.1683 0.646446 4.36356L3.82843 7.54554C4.02369 7.74081 4.34027 7.74081 4.53554 7.54554C4.7308 7.35028 4.7308 7.0337 4.53554 6.83844L1.70711 4.01001L4.53554 1.18158C4.7308 0.98632 4.7308 0.669738 4.53554 0.474476C4.34027 0.279214 4.02369 0.279214 3.82843 0.474476L0.646446 3.65646ZM71 4.01001V3.51001L1 3.51001V4.01001V4.51001L71 4.51001V4.01001Z" fill="#070707"></path>
        </svg>`);
    nextBtns.forEach(btn => btn.innerHTML = `<svg class="whatmore_next" width="71" height="8" viewBox="0 0 71 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M70.3536 4.35355C70.5488 4.15829 70.5488 3.8417 70.3536 3.64644L67.1716 0.46446C66.9763 0.269198 66.6597 0.269198 66.4645 0.46446C66.2692 0.659722 66.2692 0.976305 66.4645 1.17157L69.2929 3.99999L66.4645 6.82842C66.2692 7.02368 66.2692 7.34027 66.4645 7.53553C66.6597 7.73079 66.9763 7.73079 67.1716 7.53553L70.3536 4.35355ZM0 4L4.37114e-08 4.5L70 4.49999L70 3.99999L70 3.49999L-4.37114e-08 3.5L0 4Z" fill="#8E8E8E"></path>
        </svg>`);
    whatmoreobserver.disconnect(); // stop once updated
  }
});
whatmoreobserver.observe(target, { childList: true, subtree: true });

// product detail size js
function updateSizeValues(value) {
  const sizeChart = {
    "xxs": { bust: '32"', waist: '28"', hips: '36"', },
    "xs": { bust: '34"', waist: '30"', hips: '38"', },
    "s": { bust: '36"', waist: '32"', hips: '40"', },
    "m": { bust: '38"', waist: '34"', hips: '42"', },
    "l": { bust: '40"', waist: '36"', hips: '44"', },
    "xl": { bust: '42"', waist: '38"', hips: '46"', },
    "xxl": { bust: '44"', waist: '40"', hips: '48"', },
    "XXS": { bust: '32"', waist: '28"', hips: '36"', },
    "XS": { bust: '34"', waist: '30"', hips: '38"' },
    "S": { bust: '36"', waist: '32"', hips: '40"' },
    "M": { bust: '38"', waist: '34"', hips: '42"' },
    "L": { bust: '40"', waist: '36"', hips: '44"' },
    "XL": { bust: '42"', waist: '38"', hips: '46"' },
    "XXL": { bust: '44"', waist: '40"', hips: '48"' },
    "2XL": { bust: '44"', waist: '40"', hips: '48"' },
    "2xl": { bust: '44"', waist: '40"', hips: '48"' },
  };

  if (sizeChart[value]) {
    $(".bust-custom").text("Bust: " + sizeChart[value].bust);
    // $(".above-waist-custom").text("Above Waist: " + sizeChart[value].aboveWaist);
    $(".waist-custom").text("Waist: " + sizeChart[value].waist);
    $(".hips-custom").text("Hips: " + sizeChart[value].hips);
  }
}

$(document).on('click', '.product-form__input input', function () {
  updateSizeValues($(this).val());
});

// ✅ Run once on page load if an input is already checked
$(document).ready(function () {
  const checkedValue = $('.product-form__input input:checked').val();
  if (checkedValue) {
    updateSizeValues(checkedValue);
  }
});

function handleSizeSelection(value) {
  value = value.toLowerCase(); // normalize
  // Hide all first
  $(".product-custom-size-value, .product-custom-size, .product-plussize, .main-label, .gpo-container").hide();
  // Standard sizes
  const standardSizes = ["xxs", "xs", "s", "m", "l", "xl", "xxl","XXS","XS","S","M","L","XL","XXL","2xl","2XL"];

  if (standardSizes.includes(value)) {
    $(".product-custom-size-value, .gpo-container").show();
  } else if (value === "custom") {
    $(".product-custom-size").show();
  }else if (value === "plus-size") {
    $(".product-plussize").show();
  }
}


$(document).ready(function () {
  // Run on page load (check if any input is pre-selected)
  const selected = $(".product-form__input input:checked").val();
  if (selected) {
    handleSizeSelection(selected);
  }

  // Run on click
  $(document).on("click", ".product-form__input input", function () {
    handleSizeSelection($(this).val());
  });
});


// Product Detail Wishlist Button
const searchWishlist = document.querySelector('.product__info-wrapper .product__title + .shopify-app-block'); // section class who cut
const headerTitle = document.querySelector('.product__info-wrapper .product__title a.product__title'); // section class who after paste
if (searchWishlist && headerTitle) {
    headerTitle.insertAdjacentElement('afterend', searchWishlist);
}

// Cart page
document.addEventListener("DOMContentLoaded", function() {
    const mainContent = document.querySelector('.template-cart #MainContent');
    if (!mainContent) return;

    const firstSection = mainContent.querySelector('.cart-items-div');
    const secondSection = mainContent.querySelector('.cart__footer-wrapper');

    if (!firstSection || !secondSection) return;

    const wrapperClass = 'cart-row';

    // Check if wrapper already exists
    let wrapper = mainContent.querySelector(`.${wrapperClass}`);

    if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.classList.add(wrapperClass);
        mainContent.insertBefore(wrapper, firstSection);
        wrapper.appendChild(firstSection);
        wrapper.appendChild(secondSection);
    }

    // Nothing else on resize - keep wrapper as is
});

// empty-cart
document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelector(".is-empty")) {
        document.body.classList.add("cart-empty");
    }
});

// wishlist
function removePlusFromButtons() {
    document.querySelectorAll(".swym-storefront-layout-grid-item-add-to-cart-button").forEach(function(btn) {
        if (btn && btn.innerText) {
            btn.innerText = btn.innerText.replace("+", "").trim();
            btn.setAttribute("aria-label", btn.innerText);
        }
    });
}

// Run initially after DOM loads
document.addEventListener("DOMContentLoaded", removePlusFromButtons);

// Observe dynamically added buttons
const buttonobserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Only element nodes
                if (node.matches(".swym-storefront-layout-grid-item-add-to-cart-button")) {
                    removePlusFromButtons();
                } else {
                    // Check child buttons
                    node.querySelectorAll(".swym-storefront-layout-grid-item-add-to-cart-button").forEach(function(btn) {
                        btn.innerText = btn.innerText.replace("+", "").trim();
                        btn.setAttribute("aria-label", btn.innerText);
                    });
                }
            }
        });
    });
});

buttonobserver.observe(document.body, {
    childList: true,
    subtree: true
});

// product detail tab
document.addEventListener("DOMContentLoaded", function() {
    const buttons = document.querySelectorAll(".product_tab_btn");
    const tabs = document.querySelectorAll(".tab-pane");

    buttons.forEach((btn) => {
        btn.addEventListener("click", function() {
            buttons.forEach(b => b.classList.remove("active"));
            tabs.forEach(t => t.classList.remove("active"));

            this.classList.add("active");
            document.getElementById(this.dataset.tab).classList.add("active");
        });
    });
});

// buy now
document.addEventListener("DOMContentLoaded", function() {
  var buyNowBtn = document.getElementById("buy-it-now");
  var productForm = document.querySelector('form[action^="/cart/add"]');

  if (buyNowBtn && productForm) {
    buyNowBtn.addEventListener("click", function() {
      var formData = new FormData(productForm);
      var variantId = formData.get("id");
      var qty = formData.get("quantity") || 1;

      // Direct checkout
      window.location.href = `/checkout?add=${variantId}:${qty}`;
    });
  }
});


// whishlist-js
document.addEventListener("DOMContentLoaded", function() {
  function hideWishIcon() {
    if (document.querySelector(".swym-header-launcher")) {
      var wishIcon = document.querySelector(".wish-icon");
      if (wishIcon) {
        wishIcon.style.display = "none";
      }
    }
  }

  // Run once on load
  hideWishIcon();

  // Watch for DOM changes
  const wishlistobserver = new MutationObserver(hideWishIcon);
  wishlistobserver.observe(document.body, { childList: true, subtree: true });
});

// Mobile Header Submenu JS
document.addEventListener("DOMContentLoaded", () => {
  // Open submenu on summary click
  const menuItems = document.querySelectorAll(
    ".menu-drawer__menu.has-submenu details > summary.menu-drawer__menu-item"
  );

  menuItems.forEach(summary => {
    summary.addEventListener("click", (e) => {
      const details = summary.closest("details");
      const hasSubmenu = summary.closest(".menu-drawer__menu.has-submenu");

      // Prevent default toggle to handle classes manually
      e.preventDefault();

      // Toggle open state
      const isOpen = details.hasAttribute("open");

      if (!isOpen) {
        details.setAttribute("open", "");
        details.classList.add("menu-opening");
        if (hasSubmenu) hasSubmenu.classList.add("submenu-open");
      } else {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
        if (hasSubmenu) hasSubmenu.classList.remove("submenu-open");
      }
    });
  });

  // Close submenu on close button click
  const closeButtons = document.querySelectorAll("button.menu-drawer__close-button");

  closeButtons.forEach(button => {
    button.addEventListener("click", () => {
      const details = button.closest("details");
      const hasSubmenu = button.closest(".menu-drawer__menu.has-submenu");

      if (details) {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      }
      if (hasSubmenu) hasSubmenu.classList.remove("submenu-open");
    });
  });
});


const checkBlockerInterval = setInterval(function() {
  if (jQuery('.buckscc-currency-wrapper').length) { // ✅ fixed selector
    clearInterval(checkBlockerInterval);
    
    if (jQuery(window).width() <= 991) {
      jQuery('.buckscc-currency-wrapper').insertAfter('#sidebar-lehengas-link');
    } else {
      jQuery('.buckscc-currency-wrapper').prependTo('.header__icons');
    }
  }
}, 300);


(function () {
  function toggleCollectionFooter() {
    var footer = document.querySelector('.footer-content');
    if (!footer) return;

    if (
      document.body.classList.contains('template-collection') &&
      window.location.search.length > 0
    ) {
      footer.style.display = 'none';
    } else {
      footer.style.display = '';
    }
  }

  // Run on page load
  document.addEventListener('DOMContentLoaded', toggleCollectionFooter);

  // Run on AJAX filter / sort changes
  const pushState = history.pushState;
  history.pushState = function () {
    pushState.apply(history, arguments);
    toggleCollectionFooter();
  };

  window.addEventListener('popstate', toggleCollectionFooter);
})();




// Product card sliders: one init for all cards (was an inline script per card).
(function () {
  var SEL = '.product-card-wrapper .product-card-slider.splide';
  var io = null;

  function mount(el) {
    if (el.splide || el.querySelectorAll('.splide__slide').length < 2) return;
    // A page-speed app can set loading="lazy" on every image. Splide hides a slide image while it
    // loads, and a hidden lazy image never starts. Splide already controls when each image loads.
    el.querySelectorAll('img[data-splide-lazy]').forEach(function (img) { img.loading = 'eager'; });
    el.splide = new Splide(el, { type: 'slide', rewind: true, perPage: 1, arrows: true, pagination: true, lazyLoad: 'nearby', preloadPages: 1 }).mount();
  }

  function init() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.splide || el.dataset.cardSliderQueued) return;
      if (!('IntersectionObserver' in window)) return mount(el);
      if (!io) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.unobserve(e.target);
            mount(e.target);
          });
        }, { rootMargin: '200px' });
      }
      el.dataset.cardSliderQueued = '1';
      io.observe(el);
    });
  }

  function waitForSplide(cb, timeout) {
    if (window.Splide) return cb();
    var start = Date.now();
    var t = setInterval(function () {
      if (window.Splide) { clearInterval(t); cb(); }
      else if (Date.now() - start > timeout) clearInterval(t);
    }, 100);
  }

  waitForSplide(function () {
    init();
    ['product-grid-updated', 'collection:reloaded', 'shopify:section:load'].forEach(function (n) {
      document.addEventListener(n, init);
    });
    var timer;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var k = 0; k < nodes.length; k++) {
          var n = nodes[k];
          if (n.nodeType === 1 && ((n.matches && n.matches(SEL)) || (n.querySelector && n.querySelector(SEL)))) {
            clearTimeout(timer);
            timer = setTimeout(init, 30);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }, 5000);
})();
